module.exports = __webpack_public_path__ + "static/group-image3-ee21dfa0b2a0b4f91e129959d331a0c4.jpg";